/**
 * 截圖試驗櫃（只供 AI 呼叫，不進側欄、沒有按鈕）。
 * 產圖指令：npm run canva:export:bus-pair -- --slug=…
 * 不呼叫截圖工作箱或分時圈櫃。
 */
class ScreenshotTestCabinet {
    caseId() {
        return 'mingju-ririchun';
    }
}

function register() {
    const appCore = window.appCore;
    if (!appCore || typeof appCore.registerCabinet !== 'function') return false;
    if (appCore.getCabinet?.('screenshotTest')) return true;
    appCore.registerCabinet('screenshotTest', new ScreenshotTestCabinet());
    return true;
}

if (!register()) {
    document.addEventListener('DOMContentLoaded', register, { once: true });
}
